var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import classNames from 'classnames';
import React, { memo, useMemo } from 'react';
import ConditionalRender from '@baifendian/adhere-ui-conditionalrender';
import VerticalFlexLayout from './VerticalFlexLayout';
var selectorPrefix = 'adhere-ui-flex-layout-tool-bar-layout';
/**
 * ToolBarLayout
 * @constructor
 * @param props
 */
var ToolBarLayout = /*#__PURE__*/memo(function (props) {
  var _a, _b;
  var _c = props.topToolBarItems,
    topToolBarItems = _c === void 0 ? [] : _c,
    _d = props.bottomToolBarItems,
    bottomToolBarItems = _d === void 0 ? [] : _d,
    children = props.children,
    _e = props.className,
    className = _e === void 0 ? '' : _e,
    _f = props.topClassName,
    topClassName = _f === void 0 ? '' : _f,
    _g = props.bottomClassName,
    bottomClassName = _g === void 0 ? '' : _g,
    _h = props.mainAutoWrapClassName,
    mainAutoWrapClassName = _h === void 0 ? '' : _h,
    _j = props.topProps,
    topProps = _j === void 0 ? {} : _j,
    _k = props.bottomProps,
    bottomProps = _k === void 0 ? {} : _k,
    restProps = __rest(props, ["topToolBarItems", "bottomToolBarItems", "children", "className", "topClassName", "bottomClassName", "mainAutoWrapClassName", "topProps", "bottomProps"]);
  var topElement = useMemo(function () {
    return /*#__PURE__*/React.createElement(ConditionalRender, {
      conditional: !!(topToolBarItems || []).length
    }, function () {
      return topToolBarItems.map(function (t, index) {
        return /*#__PURE__*/React.createElement("div", {
          key: index,
          className: "".concat(selectorPrefix, "-toolbar-item")
        }, t);
      });
    });
  }, [topToolBarItems]);
  var bottomElement = useMemo(function () {
    return /*#__PURE__*/React.createElement(ConditionalRender, {
      conditional: !!(bottomToolBarItems || []).length
    }, function () {
      return bottomToolBarItems.map(function (t, index) {
        return /*#__PURE__*/React.createElement("div", {
          key: index,
          className: "".concat(selectorPrefix, "-toolbar-item")
        }, t);
      });
    });
  }, [bottomToolBarItems]);
  var targetTopProps = useMemo(function () {
    return __assign({
      fit: false
    }, topProps !== null && topProps !== void 0 ? topProps : {});
  }, [topProps]);
  var targetBottomProps = useMemo(function () {
    return __assign({
      fit: false
    }, bottomProps !== null && bottomProps !== void 0 ? bottomProps : {});
  }, [bottomProps]);
  return /*#__PURE__*/React.createElement(VerticalFlexLayout, __assign({
    className: classNames(selectorPrefix, className !== null && className !== void 0 ? className : ''),
    topClassName: classNames(topClassName, (_a = {}, _a["".concat(selectorPrefix, "-top")] = (topToolBarItems || []).length, _a)),
    bottomClassName: classNames(bottomClassName, (_b = {}, _b["".concat(selectorPrefix, "-bottom")] = (bottomToolBarItems || []).length, _b)),
    mainAutoWrapClassName: classNames("".concat(selectorPrefix, "-main-auto-wrap"), mainAutoWrapClassName !== null && mainAutoWrapClassName !== void 0 ? mainAutoWrapClassName : ''),
    topProps: targetTopProps,
    bottomProps: targetBottomProps
  }, restProps, {
    renderTop: topElement,
    renderMain: children,
    renderBottom: bottomElement
  }));
});
ToolBarLayout.displayName = 'ToolBarLayout';
export default ToolBarLayout;